<template>
  <div class="product container">
    <ul class="images">
      <li class="image__wrapper">
        <div
          class="picture__wrapper picture__wrapper--loading skeleton skeleton--light"
        ></div>
      </li>
      <li class="image__wrapper">
        <div
          class="picture__wrapper picture__wrapper--loading skeleton skeleton--light"
        ></div>
      </li>
      <li class="image__wrapper">
        <div
          class="picture__wrapper picture__wrapper--loading skeleton skeleton--light"
        ></div>
      </li>
    </ul>

    <div class="content">
      <div class="product__details">
        <span class="product__title skeleton skeleton--dark"></span>
        <span class="product__description skeleton skeleton--dark"></span>
        <div class="product__size skeleton skeleton--white"></div>
        <div class="product__button skeleton skeleton--darkest"></div>
        <div class="product__block skeleton skeleton--white"></div>
        <div class="product__block skeleton skeleton--white"></div>

        <div class="product__details__heading skeleton"></div>
        <div class="product__details__text">
          <span class="skeleton"></span>
          <span class="skeleton"></span>
          <span class="skeleton"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/components/skeleton";

.product {
  @include respond-above(md) {
    display: grid;
    grid-template-columns: 3fr 2fr;
  }

  &__title {
    display: inline-block;
    height: 23px;
    width: 100px;
    margin-bottom: 10px;
  }

  &__description {
    display: inline-block;
    height: 55px;
    width: 100%;
    margin-bottom: 20px;
  }

  &__details {
    padding: 30px 20px 0;

    @include respond-above(md) {
      padding: 80px;
    }

    &__heading {
      height: 11px;
      width: 40px;
      display: inline-block;
      margin-bottom: 20px;
    }

    &__text > * {
      height: 14px;
      width: 100%;
      display: inline-block;
      margin-bottom: 15px;

      &:nth-child(2) {
        height: 32px;
      }

      &:nth-child(3) {
        height: 28px;
      }
    }
  }

  &__size {
    height: 41px;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
  }

  &__button {
    height: 40px;
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
  }

  &__block {
    height: 50px;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
  }
}

.product.container {
  @include respond-below(md) {
    padding-left: 0;
    padding-right: 0;
  }
}

.content {
  @include respond-above(md) {
    position: sticky;
    top: 0;
    align-self: start;
  }
}

.picture__wrapper {
  display: inline-block;
  position: relative;
  width: 100%;

  &--loading {
    padding-bottom: 150%;
    width: 100%;
  }
}

.images {
  line-height: 0;
  overflow: hidden;
  white-space: nowrap;
  padding-bottom: 30px;

  @include respond-above(md) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    padding-bottom: 0;
  }

  .image__wrapper {
    display: inline-block;
    width: 100%;

    @include respond-above(md) {
      display: block;
      margin-right: 0;
    }

    &:nth-child(3n + 1) {
      grid-column: 1 / span 2;
    }
  }
}
</style>
